import cadenaDeDistribucion from "../assets/img/piezas/items/cadena-de-distribucion.webp";
import paragolpesTrasero from "../assets/img/piezas/items/paragolpes-trasero.webp";
import paragolpesDelantero from "../assets/img/piezas/items/paragolpes-delantero.webp";
import discoDeEmbrague from "../assets/img/piezas/items/disco-de-embrague.webp";
import placaDeEmbrague from "../assets/img/piezas/items/placa-de-embrague.webp";
import rodamientoDeRueda from "../assets/img/piezas/items/rodamiento-de-rueda.webp";
import brazoDeSuspension from "../assets/img/piezas/items/brazo-de-suspension.webp";
import llaveInteligente from "../assets/img/piezas/items/llave-inteligente.webp";
import parrilla from "../assets/img/piezas/items/parrilla.webp";
import semieje from "../assets/img/piezas/items/semieje.webp";
import optica from "../assets/img/piezas/items/optica.webp";
import sistemaDeEscape from "../assets/img/piezas/items/sistema-de-escape.webp";
import capot from "../assets/img/piezas/items/capot.webp";
import bujias from "../assets/img/piezas/items/bujias.webp";
import faroTrasero from "../assets/img/piezas/items/faro-trasero.webp";
import correaAccesorios from "../assets/img/piezas/items/correa-accesorios.webp";

const otrosPartsData = [
  { id: 1, title: "Cadena de distribución", url: cadenaDeDistribucion },
  { id: 2, title: "Paragolpes trasero", url: paragolpesTrasero },
  { id: 3, title: "Paragolpes delantero", url: paragolpesDelantero },
  { id: 4, title: "Disco de embrague", url: discoDeEmbrague },
  { id: 5, title: "Placa de embrague", url: placaDeEmbrague },
  { id: 6, title: "Rodamiento de rueda", url: rodamientoDeRueda },
  { id: 7, title: "Brazo de suspensión", url: brazoDeSuspension },
  { id: 8, title: "Llave inteligente", url: llaveInteligente },
  { id: 9, title: "Parrilla", url: parrilla },
  { id: 10, title: "Semieje", url: semieje },
  { id: 11, title: "Óptica", url: optica },
  { id: 12, title: "Sistema de escape", url: sistemaDeEscape },
  { id: 13, title: "Capot", url: capot },
  { id: 14, title: "Bujías", url: bujias },
  { id: 15, title: "Faro Trasero", url: faroTrasero },
  { id: 16, title: "Correa accesorios", url: correaAccesorios },
];

export default otrosPartsData;
